export default "__VITE_ASSET__C8o8ZPNJ__"